import {useEffect,useState} from 'react';
import {api} from '@/lib/api';

const CUSTOM='\u0000custom';
export default function PaymentTermsSelect({value='',onChange,terms=null,className='',emptyLabel='Company default'}) {
  const [catalog,setCatalog]=useState([]),[custom,setCustom]=useState(false),[failed,setFailed]=useState(false);
  useEffect(()=>{
    if(terms!==null)return;
    let active=true;
    api.get('/settings/quote-options').then(({data})=>{if(active)setCatalog(data?.general?.standard_payment_terms||[]);}).catch(()=>{if(active)setFailed(true);});
    return()=>{active=false;};
  },[terms]);
  const choices=[...new Set((terms??catalog).filter(item=>typeof item==='string'&&item))];
  const isCustom=custom||Boolean(value&&!choices.includes(value));
  return <span className="block"><select aria-label="Payment terms" className={className} value={isCustom?CUSTOM:value} onChange={event=>{if(event.target.value===CUSTOM){setCustom(true);}else{setCustom(false);onChange(event.target.value);}}}>
    <option value="">{emptyLabel}</option>{choices.map(term=><option key={term} value={term}>{term}</option>)}<option value={CUSTOM}>{value&&!choices.includes(value)?`Custom: ${value}`:'Custom terms…'}</option>
  </select>{isCustom&&<input aria-label="Custom payment terms" maxLength={200} className={className} value={value} onChange={event=>onChange(event.target.value)}/>}{failed&&<span role="status" className="block text-xs text-amber-700">Standard terms could not load. Custom terms are still available.</span>}</span>;
}
